import type { Role } from '@/entities/user';

/** Gateway delivery-charges admin is SUPER_ADMIN; dashboard maps to `admin`. */
export const deliveryChargesAccessRoles = ['admin'] as const satisfies readonly Role[];
